import { capitalize } from 'capitalize-lightweight';
import { ILanguage } from 'my-poppies-b2b-types';
import { useContext } from 'react';

import { LanguageContext } from '@/contexts/LanguageContext';
import { ITranslationKeys } from '@/i18n/ITranslations';
import { ITranslationFn } from '@/types/ITranslationFn';
import { ITranslationModification } from '@/types/ITranslationModification';
import { ITranslationReplaceVars } from '@/types/ITranslationReplaceVars';
import { getObjectEntries } from '@/utils/getObjectEntries';

const useTranslation = (): ITranslationFn => {
  const { t } = useContext(LanguageContext);
  return (
    key: ITranslationKeys,
    count?: number,
    modification?: ITranslationModification,
    vars: ITranslationReplaceVars = {},
    languageOverride?: ILanguage
  ): string => {
    let r = t(key, count, languageOverride);
    getObjectEntries(vars).forEach(([key, value]) => {
      if (value === undefined) {
        return;
      }
      r = r.replace(`((${key}))`, String(value));
    });
    if (modification === 'uppercase') {
      return r.toUpperCase();
    } else if (modification === 'lowercase') {
      return r.toLowerCase();
    } else if (modification === 'capitalize') {
      return capitalize(r);
    }
    return r;
  };
};

export default useTranslation;
